<template>
    <div class="container">
        <h1>Rankings</h1>
        <div class="col-lg-12" v-if="contents">
            <div class="row border rounded mt-3 mb-3 pb-3 pt-3" v-bind:key="content.id" v-for="content in contents.data">
                <div class="col-lg-12">
                    <h3>{{ content.name }}</h3>
                </div>
                <div class="col-lg-12">
                    <div class="card-deck">
                        <div class="card" style="width: 18rem;" v-bind:key="chart.id" v-for="chart in content.chart">
                            <img  class="card-img-top" :src="chart.image" alt="">
                            <div class="card-body">
                                <h5 class="card-title">{{ chart.title }}</h5>
                                <p class="card-text">{{ chart.description }}</p>
             
                                <router-link :to="{name: 'chart', params: { id: chart.id }}" class="btn btn-outline-dark ion-ios-eye-outline"> view</router-link>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            content: this.$route,
            contents: null,
            error: null,
        }
    },
    created() {
        console.log(this.content);
        this.getContent()
    },
    methods: {
        getContent() {
            let self = this;
         
            axios.get(this.computed.apiGateway + '/api/v1/rankings' )
                .then(response => this.contents = response.data)
                .catch(error => self.error = error.response)
        }
    }
}
</script>